<template>
  <v-container fluid class="bg-background ma-0 pt-0 pl-4 pr-4">
    <div>
      <v-row>
        <v-col cols="12">
          <h3 class="mx-4">{{ report.name }} | Report</h3>
        </v-col>
      </v-row>
    </div>
    <v-row class="mt-1">
      <v-col cols="12">
        <v-hover v-slot="{ isHovering, props }">
          <v-card
            elevation="0"
            :class="{ 'on-hover': isHovering }"
            class="px-4 py-1 combinedReportCard"
            v-bind="props"
          >
            <v-card-text>
              <v-row dense justify="space-between" class="align-center">
                <div class="w-100 d-flex">
                  <v-col class="w-25"> </v-col>

                  <v-col class="w-25">
                    <v-row dense class="align-center ma-0 pa-0 mb-2">
                      <v-col
                        class="t-h6 pa-0 mr-2"
                        :class="
                          $vuetify.display.width < 440
                            ? 'small-font  h-100 d-flex align-center justify-center'
                            : ''
                        "
                        cols="auto"
                      >
                        Marks Obtained
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col class="w-25">
                    <v-row dense class="align-center ma-0 pa-0 mb-2">
                      <v-col
                        class="t-h6 ma-0 pa-0 mr-2"
                        :class="
                          $vuetify.display.width < 440
                            ? 'small-font  h-100 d-flex align-center justify-center'
                            : ''
                        "
                        cols="auto"
                      >
                        Max Marks
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col class="w-25">
                    <v-row dense class="align-center ma-0 pa-0 mb-2">
                      <v-col
                        class="t-h6 ma-0 pa-0"
                        :class="
                          $vuetify.display.width < 440
                            ? 'small-font  h-100 d-flex align-center justify-center'
                            : ''
                        "
                        cols="auto"
                      >
                        Combined Rank
                      </v-col>
                    </v-row>
                  </v-col>
                </div>

                <div class="w-100 d-flex">
                  <v-col
                    class="w-25"
                    :class="$vuetify.display.width < 440 ? 'padding-0' : ''"
                  >
                    <v-row dense class="ma-0 pa-0 h-100">
                      <v-col
                        class="t-h6"
                        :class="
                          $vuetify.display.width < 440
                            ? 'small-font  h-100 d-flex align-center justify-center'
                            : ''
                        "
                        cols="auto"
                      >
                        Combined Result
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col class="w-25">
                    <v-row
                      dense
                      :class="
                        $vuetify.display.width < 440
                          ? 'd-flex h-100 align-center justify-center ma-0 pa-0 mb-2'
                          : ''
                      "
                    >
                      <v-col
                        class="d-flex align-center justify-center t-h5"
                        cols="auto"
                      >
                        {{ result.TotalMarks }}
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col class="w-25">
                    <v-row
                      dense
                      :class="
                        $vuetify.display.width < 440
                          ? 'd-flex h-100 align-center justify-center ma-0 pa-0 mb-2'
                          : ''
                      "
                    >
                      <v-col
                        class="d-flex align-center justify-center t-h5"
                        cols="auto"
                      >
                        {{ result.TotalTestMarks }}
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col class="w-25">
                    <v-row
                      dense
                      :class="
                        $vuetify.display.width < 440
                          ? 'd-flex h-100 align-center justify-center ma-0 pa-0 mb-2'
                          : ''
                      "
                    >
                      <v-col
                        class="d-flex align-center justify-center t-h5"
                        cols="auto"
                      >
                        {{ result.TotalRank }}
                      </v-col>
                    </v-row>
                  </v-col>
                </div>

                <div
                  class="w-100 d-flex"
                  v-for="(item, index) in subjects"
                  :key="index"
                >
                  <v-col
                    :class="$vuetify.display.width < 440 ? 'padding-0' : ''"
                    class="w-25"
                  >
                    <v-row dense class="ma-0 pa-0 h-100">
                      <v-col
                        class="t-h6"
                        :class="
                          $vuetify.display.width < 440
                            ? 'small-font  h-100 d-flex align-center justify-center'
                            : ''
                        "
                        cols="auto"
                      >
                        {{ item }}
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col class="w-25">
                    <v-row
                      dense
                      :class="
                        $vuetify.display.width < 440
                          ? 'd-flex h-100 align-center justify-center ma-0 pa-0 mb-2'
                          : ''
                      "
                    >
                      <v-col
                        class="d-flex align-center justify-center t-h5"
                        cols="auto"
                      >
                        {{ result.SubjectWiseMarks[item] }}
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col class="w-25">
                    <v-row
                      dense
                      :class="
                        $vuetify.display.width < 440
                          ? 'd-flex h-100 align-center justify-center ma-0 pa-0 mb-2'
                          : ''
                      "
                    >
                      <v-col
                        class="d-flex align-center justify-center t-h5"
                        cols="auto"
                      >
                        {{ result.MaxSubjectWiseMarks[item] }}
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col class="w-25">
                    <v-row
                      dense
                      :class="
                        $vuetify.display.width < 440
                          ? 'd-flex h-100 align-center justify-center ma-0 pa-0 mb-2'
                          : ''
                      "
                    >
                      <v-col
                        class="d-flex align-center justify-center t-h5"
                        cols="auto"
                      >
                        {{ result.RankSubjectWise[item] }}
                      </v-col>
                    </v-row>
                  </v-col>
                </div>
              </v-row>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <v-divider class="mt-8"></v-divider>

    <v-row class="ml-3 my-6">
      <span class="text-white bx-big-combinedReport">
        <h3 class="">Test Wise Reports</h3>
      </span>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12">
        <v-row v-for="item in report.tests" :key="item.testId">
          <SingleTestReportComponent :id="item.testId" :name="item.name" />
        </v-row>
      </v-col>
    </v-row>
    <v-divider class="mt-8"></v-divider>

    <v-row class="ml-3 my-6">
      <span class="w-auto text-white bx-big-combinedReport">
        <h3 class="w-auto">Top Performers</h3>
      </span>
    </v-row>

    <v-row class="mt-6" dense>
      <v-col
        cols="12"
        v-for="(student, index) in report.top20"
        :key="index"
        class="mb-3"
      >
        <v-card
          :class="isTop20(index, student.studentName) ? 'top-20' : ''"
          class="d-flex ga-4 align-center pa-1 elevation-1"
        >
          <v-col
            cols="3"
            class="student-name text-truncate font-weight-bold text-truncate"
          >
            <span
              v-if="isTop20(index, student.studentName)"
              class="mdi mdi-star-shooting-outline"
            ></span>
            {{ student.studentName }}
          </v-col>

          <v-col cols="1" class="student-rank font-weight-bold">
            Rank : {{ student.rank }}
          </v-col>
          <v-col cols="2" class="font-weight-bold">
            Total Marks : {{ student.totalMarks }}
          </v-col>
          <div v-for="(subject, ind) in subjects" :key="ind">
            <v-col cols="auto" class="font-weight-bold">
              {{
                `${subject} : ${report.top20[index].subjectWiseMarks[subject]}`
              }}
            </v-col>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import SingleTestReportComponent from "./SingleTestReportComponent.vue";

export default {
  name: "CombinedReportPage",
  props: ["report"],
  created() {},
  components: {
    SingleTestReportComponent
  },
  computed: {
    ...mapState(["userState"]),
    result: {
      get() {
        return this.$store.state.studentCombinedTestReport;
      }
    },
    subjects: {
      get() {
        let data = this.$store.state.studentCombinedTestReport;

        if (data && data.SubjectWiseMarks) {
          //console.log(Object.keys(data.SubjectWiseMarks));
          return Object.keys(data.SubjectWiseMarks);
        }
        return [];
      }
    }
  },
  methods: {
    isTop20(index, name) {
      return (
        this.result.TotalRank <= 20 && name === localStorage.getItem("name")
      );
    }
  }
};
</script>

<style>
.bx-big-combinedReport {
  display: flex;
  align-items: center;
  background-color: rgb(100, 100, 235);
  border: 1px solid #e7e7e7;
  border-radius: 5px;
  height: 20px;
  padding: 20px;
  font-size: 18px;
  max-width: 300px;
  margin-right: 20px;
}

.v-card.on-hover {
  border-color: transparent;
  background-color: rgba(246, 246, 246, 0.619);
  box-shadow: 0px 2px 12px rgba(155, 178, 245, 0.2) !important;
  border: 1px solid #dcdcdc;
}

.combinedReportCard {
  box-shadow: 0px 2px 5px 10px rgba(15, 27, 38, 0.278);
  border-radius: 5px;
  background-color: rgb(var(--v-theme-navColor));
  border: 1px solid #dcdcdc;
}
.student-rank {
  font-size: 1.2rem;
  color: #1976d2;
}
.student-name {
  font-size: 1.1rem;
  color: #424242;
}
.top-20 {
  background-color: #fafafa !important; /* Light blue */
  border-left: 4px solid #19d244; /* Blue accent */
  box-sizing: border-box;
}
.top-20:hover {
  background-color: #efffea !important; /* Light blue */
  border-left: 4px solid #40ceeb; /* Blue accent */
  box-sizing: border-box;
}
.get-left {
  margin-left: -4px;
}
.small-font {
  font-size: 10px !important;
}
.padding-0 {
  padding: 4px !important;
}
</style>
